import msg from './_msg.js';
import imgList from './imgList';


// eslint-disable-next-line
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
let utils = {
  prefix: "/manager",
  prefix_auth: "/manager",
  prefix_m: "/express/manager",
  prefix_o: "/express/operator",
  prefix_a: "/express/auth",
  storagePrefix: 'ssoLogin-',
  isUrl: function (path) {
    return reg.test(path)
  },
  // 枚举值最大字符量
  maxEnumVal: 1000,
  // 300毫秒内连续点击不触发事件
  WAIT_TIME: 300,
  // 密码正则校验 允许输入字母数字及@#$%^&*_-等特殊字符
  pwdReg:/^[a-zA-Z0-9$@$#%^&*_-]*$/,
  pwdCheckMsg:'仅支持半角英文,半角数字及@$#%^&*_-等特殊字符',
  tell:{
    reg:/^\d{11}$/,
    msg: "仅限11位的正整数"
  },
  msg,
  imgList,
  isEmpty: function (obj) {
    return obj === null || obj === undefined || obj === "" || obj === '' || obj === "null" || typeof obj === "undefined"
  },
  setStorage(keyname, val) {
    keyname = this.storagePrefix + keyname
    localStorage.setItem(keyname, val)
    // this.setCookie()
  },
  getStorage(keyname) {
    keyname = this.storagePrefix + keyname
    let r;
    try {
      r = localStorage.getItem(keyname);
    } catch (error) {
      return null
    }
    return r
  },
  removeStorage(keyname) {
    keyname = this.storagePrefix + keyname
    localStorage.removeItem(keyname);
  },
  /**
   * 获取文件后缀名
   */
  getFileSuffix(fileUrl) {
    let index1 = fileUrl.lastIndexOf("."), index2 = fileUrl.length;
    let type = '';
    if (index1 >= 0) {
      // 存在文件扩展名
      type = fileUrl.substring(index1, index2)
    }
    return type;
  },
  /*根据出生日期算出年龄*/
  getAgeFromID(strBirthday) {
    let returnAge;
    let strBirthdayArr = strBirthday.split("-");
    let birthYear = strBirthdayArr[0];
    let birthMonth = strBirthdayArr[1];
    let birthDay = strBirthdayArr[2];

    let d = new Date();
    let nowYear = d.getFullYear();
    let nowMonth = d.getMonth() + 1;
    let nowDay = d.getDate();

    if (nowYear === birthYear) {
      returnAge = 1; //同年 则为1岁
    }
    else {
      let ageDiff = nowYear - birthYear; //年之差
      if (ageDiff > 0) {
        if (nowMonth === birthMonth) {
          let dayDiff = nowDay - birthDay;//日之差
          if (dayDiff < 0) {
            returnAge = ageDiff - 1;
          }
          else {
            returnAge = ageDiff;
          }
        }
        else {
          let monthDiff = nowMonth - birthMonth;//月之差
          if (monthDiff < 0) {
            returnAge = ageDiff - 1;
          }
          else {
            returnAge = ageDiff;
          }
        }
      }
      else {
        returnAge = ''; //返回-1 表示出生日期输入错误 晚于今天
      }
    }

    return returnAge;//返回周岁年龄

  },
  // 枚举值 json字符串转为string
  // limitNum 截取字符个数 'all' 全部截取 20 直截取前20个字符
  enumValToStr(val, limitNum) {
    let jsonVal = null;
    if (!!val && typeof val === 'string' && val.split('').splice(-2, 1) === '}') {
      jsonVal = JSON.parse(val)
    }

    if (!!jsonVal && Array.isArray(jsonVal) && jsonVal.length > 0) {
      if (limitNum === 'all') {
        return jsonVal.map(item => item.name).join(',')
      } else {
        return jsonVal.map(item => item.name).join(',').slice(0, 20)
      }
    }
  },
  // 枚举值 json字符串转为list
  enumValToList(val) {
    let jsonVal = null;
    if (!!val && typeof val === 'string' && val.split('').splice(-2, 1) === '}') {
      jsonVal = JSON.parse(val)
    }

    if (!!jsonVal && Array.isArray(jsonVal) && jsonVal.length > 0) {
      return jsonVal
    } else {
      return []
    }
  },
  /**
   * 生成唯一标识码uuid 32位
   */
  guid() {
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // & | 从左到右执行
    let r = Math.random() * 16 | 0,
        v = c === 'x' ? r : ((r & 0x3) | 0x8);
      return v.toString(16);
    });
    return uuid.replace(/-/g, '')
  },
  // 两位半角大写英文字符
  validEngWord(rule, value, callback) {
    let reg = /^[A-Z]{2}$/
    if (!reg.test(value)) {
      callback(new Error('2位半角英文字符'))
    } else {
      callback()
    }
  },
  // 两位半角英文字符
  validEngWord_one(rule, value, callback) {
    let reg = /^[a-zA-Z]{1,2}$/
    if (!reg.test(value)) {
      callback(new Error('1或2位半角英文字符'))
    } else {
      callback()
    }
  },
  // 只允许半角英文、半角数字、下划线
  validEngNumUnder(rule, value, callback) {
    let reg = /^[a-zA-Z0-9_]*$/
    if (!reg.test(value)) {
      callback(new Error('请输入半角英文,半角数字,下划线'))
    } else {
      callback()
    }
  },
  // 只允许半角英文、半角数字
  validEngNum(rule, value, callback) {
    let reg = /^[a-zA-Z0-9]*$/
    if (!reg.test(value)) {
      callback(new Error('请输入半角英文,半角数字'))
    } else {
      callback()
    }
  },
  // 序号允许输入0~127之间的整数
  validOrderNum(rule, value, callback) {
    let reg = /^[0-9]*$/
    if (!reg.test(value)) {
      callback(new Error('请输入0~127的整数'))
    }
    else if (value > 127) {
      callback(new Error('请输入0~127的整数'))
    }
    else {
      callback()
    }
  },
  // 判断是否是正则表达式
  validRegx_js(value) {
    // 检测开头和结尾 是否以// 为准
    let i_first = value.substring(0, 1);
    let i_last = value.substring(value.length - 1, value.length);

    let result;

    if (i_first === "/" || i_last === "/") {
      result = false;
      console.log("validRegx_js 正则表达式 有错误, 不需要 /开头，或者/结尾")// 后期 校验值 手动加//
    }
    else {
      //result = false;
      try {
        let regx = new RegExp(value);
        if (regx.test('aa') || true) {
          result = true;
          console.log("validRegx_js 正则表达式 正确。", value, "value.test('aa')", regx.test('aa'))
        }
      } catch (error) {
        result = false
        console.log("validRegx_js 正则表达式 有错误")
      }
    }
    return result;
  },
  // 格式化小数
  limitDecimals(value) {
    // 限制小数位可以输到不超过5位
    // eslint-disable-next-line
    const reg = /^(\-)*(\d+)\.(\d\d\d\d\d).*$/; 
    if(typeof value === 'string') {
        return !isNaN(Number(value)) ? value.replace(reg, '$1$2.$3') : ''
    } else if (typeof value === 'number') {
        return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : ''
    } else {
        return ''
    }
  },
  // 只能输入整数
  limitOutNum(value) {
    if (typeof value === 'string') {
      return !isNaN(Number(value)) ? value.replace(/^(0+)|[^\d]/g, '') : ''
    } else if (typeof value === 'number') {
      return !isNaN(value) ? String(value).replace(/^(0+)|[^\d]/g, '') : ''
    } else {
      return ''
    }
  },
  // 图片地址转为base64
  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  },
  // 是否为对象类型数据
  isObj(obj){
    return Object.prototype.toString.call(obj) === '[object Object]'
  },
  // 将value值为空的key过滤掉，返回对象
  filterEmptyKey(data){
    if(data==null || !this.isObj(data)){
      data = {}
    }
    let _values = {};
    for(let key in data){
      if(this.isEmpty(data[key])){
        continue
      }
      _values[key] = data[key]
    }
    console.log('values',_values)
    return _values
  },
  // 获取search参数值
  getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
  }
};

export default utils

